import api from './api';

export const getGlobalRanking = (page = 1) => api.get('/api/rankings/global', { params: { page } });
export const getCityRanking = (cityId, page = 1) => api.get(`/api/rankings/city/${cityId}`, { params: { page } });
export const getWeeklyRanking = (page = 1) => api.get('/api/rankings/weekly', { params: { page } });
export const getAchievementRanking = (page = 1) => api.get('/api/rankings/achievements', { params: { page } });
